function initCustomCarFilter() {

    $('.customFilterCategory').each(function () {

        const $container = $(this);
        $container.data('currentTargetUrl', null);
        $container.empty();
        /* =========================
           HELPERS
        ========================= */

        function createCustomSelect(labelText, placeholder) {
            const $wrapper = $('<div class="customSelectWrapper"></div>');
            const $label = $('<label>' + labelText + '</label>');
            const $display = $(`
                <div class="customSelectDisplay">
                    <span class="selected-label">${placeholder}</span>
                    <span>▼</span>
                </div>
            `);
            const $options = $('<div class="customOptions"></div>');

            $wrapper.append($label, $display, $options);
            return { $wrapper, $display, $options };
        }

        function enableButton() {
            $filterWrap.removeClass('disabled').css({
                opacity: 1,
                pointerEvents: 'auto'
            });
        }

        /* =========================
           GLOBAL CLICK (JEDNOU)
        ========================= */

        $container.on('click', function (e) {
            if (!$(e.target).closest('.customSelectWrapper').length) {
                $container.find('.customOptions').hide();
            }
        });

        function bindCustomSelect(selectObj, onSelect) {

            // 🔥 ODVAŽ staré eventy
            selectObj.$display.off('click');
            selectObj.$options.off('click', '.customOption');

            selectObj.$display.on('click', function (e) {
                e.stopPropagation();
                if (selectObj.$wrapper.hasClass('disabled')) return;
                $container.find('.customOptions').not(selectObj.$options).hide();
                selectObj.$options.toggle();
            });

            selectObj.$options.on('click', '.customOption', function (e) {
                e.stopPropagation();

                selectObj.$options.find('.customOption').removeClass('selected');
                $(this).addClass('selected');

                const name = $(this).data('name');
                const img = $(this).data('img');
                const href = $(this).data('href');

                const $label = $('<span class="selected-label"></span>');
                if (img) $label.append(`<img src="${img}">`);
                $label.append(`<span>${name}</span>`);

                selectObj.$display.find('.selected-label').replaceWith($label);
                selectObj.$options.hide();

                if (typeof onSelect === 'function') {
                    onSelect({ name, img, href });
                }
            });
        }

        function resetSelect(selectObj, placeholder, disable = true) {

            // reset text
            selectObj.$display.find('.selected-label').replaceWith(
                `<span class="selected-label">${placeholder}</span>`
            );

            // vyčisti options
            selectObj.$options.empty();

            // zneaktivni / aktivuj
            if (disable) {
                selectObj.$wrapper
                    .addClass('disabled')
                    .css({ opacity: 0.6, pointerEvents: 'none' });
            } else {
                selectObj.$wrapper
                    .removeClass('disabled')
                    .css({ opacity: 1, pointerEvents: 'auto' });
            }
        }

        /* =========================
           BUTTON
        ========================= */

        const $filterBtn = $('<button class="btn btn-primary">Zobrazit autodoplňky</button>');
        const $filterWrap = $(`
            <div class="customSelectWrapper buttonWrap disabled"
                 style="opacity:0.6; pointer-events:none;"></div>
        `);

        $filterWrap.append($filterBtn);
        $container.append($filterWrap);

        $filterBtn.on('click', function () {
            const url = $container.data('currentTargetUrl');
            if (!url) return;
            window.location.href = url;
        });

        /* =========================
           LOAD BRANDS
        ========================= */

        $.ajax({
            url: '/autodoplnky-podle-modelu-auta/',
            method: 'GET',
            success: function (data) {

                const html = $(data);
                const $brands = html.find('ul.subcategories.with-image li');
                if (!$brands.length) return;

                const brandSelect = createCustomSelect('Typ auta', 'Např. Volkswagen');
                const typeSelect  = createCustomSelect('Model auta', 'Např. Passat');
                const yearSelect  = createCustomSelect('Rok výroby', 'Např. 2025');

                typeSelect.$wrapper.addClass('disabled').css({ opacity: 0.6, pointerEvents: 'none' });
                yearSelect.$wrapper.addClass('disabled').css({ opacity: 0.6, pointerEvents: 'none' });

                $container.append(
                    brandSelect.$wrapper,
                    typeSelect.$wrapper,
                    yearSelect.$wrapper
                );

                /* ===== Brands ===== */

                $brands.each(function () {

    const $a = $(this).find('a');
    const $img = $a.find('img');

    const realImg = getRealImage($img);
    const name = $.trim($a.find('.text').text());

    brandSelect.$options.append(
        $('<div class="customOption"></div>')
            .data({
                name: name,
                img: realImg,
                href: $a.attr('href')
            })
            .append(realImg ? `<img src="${realImg}">` : '')
            .append(`<span>${name}</span>`)
    );
});

                bindCustomSelect(brandSelect, function (brand) {

                    $container.data('currentTargetUrl', brand.href);
                    enableButton();
                    resetSelect(typeSelect, 'Např. Passat');
resetSelect(yearSelect, 'Např. 2025');

// povol model
resetSelect(typeSelect, 'Např. Passat', false);


                    typeSelect.$options.empty();
                    typeSelect.$wrapper.removeClass('disabled').css({ opacity: 1, pointerEvents: 'auto' });
                    yearSelect.$wrapper.addClass('disabled').css({ opacity: 0.6, pointerEvents: 'none' });

                    $.get(brand.href, function (data) {

                        const html = $(data);
                        const $models = html.find('ul.subcategories.with-image li');
              
$models.each(function () {

    const $a = $(this).find('a');
    const realImg = getRealImage($a.find('img'));
    const name = $.trim($a.find('.text').text());

    typeSelect.$options.append(
        $('<div class="customOption"></div>')
            .data({
                name: name,
                img: realImg,
                href: $a.attr('href')
            })
            .append(realImg ? `<img src="${realImg}">` : '')
            .append(`<span>${name}</span>`)
    );
});

                        bindCustomSelect(typeSelect, function (type) {
resetSelect(yearSelect, 'Např. 2025');

// povol rok
resetSelect(yearSelect, 'Např. 2025', false);
                            $container.data('currentTargetUrl', type.href);
                            enableButton();

                            yearSelect.$options.empty();
                            yearSelect.$wrapper.removeClass('disabled').css({ opacity: 1, pointerEvents: 'auto' });

                            $.get(type.href, function (data) {

                                const html = $(data);
                                const $years = html.find('ul.subcategories.with-image li');

                                $years.each(function () {
                                    const $a = $(this).find('a');
                                       
                                    yearSelect.$options.append(
                                     
                                        $('<div class="customOption"></div>')
                                            .data({
                                                name: $.trim($a.find('.text').text()),
                                                img:  $a.find('img').attr('data-src'),
                                                href: $a.attr('href')
                                            })
                                            .append(`<span>${$a.find('.text').text()}</span>`)
                                    );
                                });

                                bindCustomSelect(yearSelect, function (year) {
                                    $container.data('currentTargetUrl', year.href);
                                    enableButton();
                                });

                            });
                        });

                    });
                });

            }
        });

    });

    function getRealImage($img) {

    if (!$img.length) return null;

    const img =
        $img.attr('data-src') ||
        $img.attr('data-lazy') ||
        $img.attr('data-original') ||
        $img.attr('src');

    if (!img) return null;

    // ignoruj SVG placeholder
    if (img.startsWith('data:image/svg')) return null;

    return img;
}


};


$(function () {
    initCustomCarFilter();
});

$(document).on('ShoptetDOMPageContentLoaded', function () {
    initCustomCarFilter();
});